export default __webpack_public_path__ + "static/media/bl-gift-card.64b2cdb9.png";